var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0761719 7.33435C0.0761719 3.4744 3.21622 0.334351 7.07617 0.334351C10.9361 0.334351 14.0762 3.4744 14.0762 7.33435C14.0762 11.1943 10.9361 14.3344 7.07617 14.3344C3.21622 14.3344 0.0761719 11.1943 0.0761719 7.33435ZM6.83232 9.64255L10.624 5.85095C10.8521 5.6228 10.8521 5.2542 10.624 5.02615C10.3959 4.798 10.0273 4.798 9.79922 5.02615L6.41992 8.40535L4.93652 6.92195C4.70837 6.6938 4.33977 6.6938 4.11172 6.92195C3.88358 7.14999 3.88358 7.51871 4.11172 7.74675L6.00752 9.64255C6.12128 9.7563 6.2706 9.81355 6.41992 9.81355C6.56924 9.81355 6.71857 9.7563 6.83232 9.64255Z",
    fill: "#DFB322"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.4232249d8f0ef17e0570a6b5409b271a.svg";
export { ForwardRef as ReactComponent };